import { getConsole } from './getConsole'

// ANSI escape codes for coloring
const colors = {
  green: '\x1b[32m',
  cyan: '\x1b[36m',
  red: '\x1b[31m',
  purple: '\x1b[35m', // Purple for cached requests
  yellow: '\x1b[33m', // Yellow for menu clicks
  pink: '\x1b[35m', // Pink for checkpoints
  white: '\x1b[37m', // White for default messages
  reset: '\x1b[0m',
}
export { colors }

// Initialize app started time only once
if (!window.appStartedTime) {
  window.appStartedTime = Date.now()
}

// Global error handler event (for uncaught errors)
window.addEventListener('error', (event) => {
  logger.error('Uncaught Error:', event.error || event.message)
})

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled Promise Rejection:', event.reason)
})

// Enhanced error logging function
const error = (errorMessage, error) => {
  if (errorMessage instanceof Error && error === undefined) {
    error = errorMessage
    errorMessage = errorMessage.message
  }

  const formattedMessage = `${colors.red}Error: ${errorMessage}${colors.reset}`

  if (error) {
    if (error instanceof Error && error.stack) {
      getConsole.error(formattedMessage, error.stack)
    } else {
      getConsole.error(formattedMessage, error)
    }
  } else {
    getConsole.error(formattedMessage)
  }
}

// Service request logging function
const serviceRequest = (methodName, params) => {
  const formattedParams = JSON.stringify(params)
  getConsole.log(`${colors.green}Service Request: ${methodName} with params: ${formattedParams}${colors.reset}`)

  const startTime = performance.now()

  return (cached = false) => {
    const duration = (performance.now() - startTime).toFixed(2)
    const color = cached ? colors.purple : colors.cyan
    const logMessage = cached
      ? `${color}Cached Request Time for ${methodName}: ${duration} ms${colors.reset}`
      : `${color}Request Time for ${methodName}: ${duration} ms${colors.reset}`

    getConsole.log(logMessage)
  }
}

const menuClicked = (menuId) => {
  getConsole.log(`${colors.yellow}Menu Item Clicked: ${menuId}${colors.reset}`)
}

const checkpoint = (message) => {
  const elapsed = Date.now() - window.appStartedTime
  getConsole.log(`${colors.pink}Checkpoint: ${message} (Elapsed Time: ${elapsed} ms)${colors.reset}`)
}

const log = (...objects) => {
  getConsole.log(...objects)
}

const logWithTime = (logTag, fileName, message, data = null, messageColor = colors.white) => {
  const elapsedSeconds = ((Date.now() - window.appStartedTime) / 1000).toFixed(2)

  // Ensure message is a string
  const safeMessage = message || 'No message provided'

  // Format data if present
  let formattedData = null
  if (data) {
    try {
      formattedData = typeof data === 'object' ? JSON.stringify(data, null, 2) : data
    } catch (e) {
      formattedData = 'Unable to stringify data'
    }
  }

  const logMessage = `${colors.cyan}[${logTag}]${colors.reset}[${colors.yellow}${fileName}${colors.reset}][${colors.green}${elapsedSeconds}s${colors.reset}] ${messageColor}${safeMessage}${colors.reset}`

  if (formattedData) {
    getConsole.log(logMessage, formattedData)
  } else {
    getConsole.log(logMessage)
  }
}

export const logger = {
  log,
  error,
  serviceRequest,
  menuClicked,
  checkpoint,
  logWithTime,
}
